import React from "react";

const Header = () => {
  return (
    <div>
      <h1>NBA Memory Game</h1>
    </div>
  );
};

export default Header;
